












































































import { Component, Mixins } from 'vue-mixin-decorator';
import { SlotMixin } from '@/mixins/SlotMixin';
import WorkLayout from '@/views/layouts/WorkLayout.vue';
import { GET_ENTERPRISE, GET_STATUS } from '@/store/models/work/enterprises';
import { Enterprise } from '@/resources/enterprise/Enterprise';
import { Getter, namespace } from 'vuex-class';
import Http from '@/Http';
import Pagination from '@/components/Pagination.vue';
import { PageMeta } from '@/types/pagination';
import { Watch } from 'vue-property-decorator';
import { History } from '@/types/work/invoice';
import { NAMESPACE as P_NAMESPACE } from '@/store/models/work/enterprise/positions';
import { GET_ITEMS, ITEMS_REQUEST } from '@/store';
import { PositionModel } from '@/store/types/work/Positions';
import LogItem from '@/components/work/LogItem.vue';

const positionsStore = namespace(P_NAMESPACE);
@Component({
  components: { LogItem, Pagination, WorkLayout }
})
export default class WorkEnterpriseShow extends Mixins<SlotMixin>(SlotMixin) {
  @Getter(GET_ENTERPRISE) enterprise!:Enterprise;
  @Getter(GET_STATUS) status!:boolean|null;

  @positionsStore.Action(ITEMS_REQUEST) positionsRequest: any;
  @positionsStore.Getter(GET_ITEMS) positions!:PositionModel[];

  public logModels = [
    { key: 'invoice', title: 'Накладні' },
    { key: 'provider', title: 'Постачальники/Замовники' }
  ]

  public meta: PageMeta = {
    current_page: 1,
    from: 1,
    to: 1,
    per_page: 1,
    last_page: 1,
    total: 1
  };
  @Watch('$route.query')
  onQueryChanged () {
    this.getLogs();
  }

  public filters = {
    user_id: null,
    model: null
  };

  public history: History[] = [];

  public loading ():boolean {
    return this.status !== null;
  }

  public getLogs () {
    (new Http()).request({
      url: `enterprise/${this.enterprise.id}/logs`,
      params: {
        ...this.$route.query,
        filters: { ...this.filters }
      }
    }).then((res: any) => {
      this.history = res.data.data;
      this.meta = res.data.meta;
    });
  }

  public created () {
    this.positionsRequest();
    this.getLogs();
    this.$gtag.event('page_view', {});
  }
}
